import React, { useEffect, useState } from "react";
import { Spin, Steps, message } from "antd";
import { useDispatch } from "react-redux";
import get from "lodash/get";
import map from "lodash/map";
import uniq from "lodash/uniq";

import BasicInfo from "./forms/basicInfo";
import GraphInfo from "./forms/graphInfo";

import {
  ADD_TEMPLATE_SUCCESS,
  UPDATE_TEMPLATE_SUCCESS,
} from "../../constants/message";

import {
  fetchEntityHeirarcy,
  fetchDeviceByIds,
} from "../../redux/actions/entityActions";
import {
  addTemplate,
  updateTemplate,
} from "../../redux/actions/templateActions";
import {
  generateStep1Payload,
  generateStep2Payload,
  generateStep3Payload,
  generateInitialPayload,
} from "../../utilities/template";

import { getGatewayDeviceHierarchy } from "../../utilities/entity";
import {
  SnippetsOutlined,
  BarChartOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import TemplateMetaValue from "./forms/templateMetaValue";

const AddEditTemplate = ({
  toggle,
  data,
  refresh,
  edit,
  companies,
}) => {
  const dispatch = useDispatch();
  const [entityTree, setEntityTree] = useState([]);

  const [loading, setLoading] = useState(false);
  const [graphLocalState, setGraphLocalState] = useState(
    map(Array(6), () => undefined)
  );

  const [step, setStep] = useState(0);

  const [formValues, setFormValues] = useState({
    step1: undefined,
    step2: undefined,
    step3: { rejected_count: 0 },
  });

  const onSelectLocation = (locationId) => {
    setLoading(true);
    dispatch(fetchEntityHeirarcy("LOCATION", locationId))
      .then((result) => {
        setLoading(false);
        const eTree = getGatewayDeviceHierarchy(
          get(result, "locationVOS.0.gatewayVOList", []),
          get(result, "locationVOS.0.orphanDeviceVOList", [])
        );
        setEntityTree(eTree);
        if (edit) {
          getDevicesDetails(data, eTree);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onCreateTemplate = (payload) => {
    setLoading(true);
    dispatch(addTemplate(payload))
      .then(() => {
        setLoading(false);
        message.success(ADD_TEMPLATE_SUCCESS);
        refresh();
        toggle();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onUpdateTemplate = (payload) => {
    setLoading(true);
    dispatch(updateTemplate(get(data, "id"), payload))
      .then(() => {
        setLoading(false);
        message.success(UPDATE_TEMPLATE_SUCCESS);
        refresh();
        toggle();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onSubmitFormValue = (values, step) => {
    switch (step) {
      case 1:
        setFormValues({
          ...formValues,
          step1: values,
        });
        setStep(1);
        break;
      case 2:
        setFormValues({
          ...formValues,
          step2: values,
        });
        setStep(2);
        break;
      case 3:
        setFormValues({
          ...formValues,
          step3: values,
        });
        const payload = {
          ...generateStep1Payload(get(formValues, "step1")),
          ...generateStep2Payload(
            get(formValues, "step2"),
            graphLocalState,
            edit,
            get(formValues, "step1.type_id")
          ),
          ...generateStep3Payload(values),
        };

        if (edit) {
          onUpdateTemplate(payload);
        } else onCreateTemplate(payload);
    }
  };

  const goToStep = (step) => {
    setStep(step);
  };

  const getDevicesDetails = (data, eTree) => {
    const deviceIds = uniq(
      map(get(data, "template_settings", []), "device_id")
    );
    setLoading(true);
    dispatch(fetchDeviceByIds(deviceIds))
      .then((result) => {
        const { formValues, localState } = generateInitialPayload(
          data,
          get(result, "list"),
          eTree
        );

        setGraphLocalState(localState);
        setFormValues(formValues);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (edit) {
      onSelectLocation(get(data, "company.location_id"));
    }
  }, []);
  return (
    <div className="h-full flex flex-col">
      <Spin spinning={loading}>
        <Steps
          current={step}
          items={[
            {
              title: "Basic",
              icon: <SnippetsOutlined />,
            },
            {
              title: "Graph",
              icon: <BarChartOutlined />,
            },
            {
              title: "Template data",
              icon: <ProfileOutlined />,
            },
          ]}
        />
        {((edit && get(formValues, "step1")) || !edit) && (
          <>
            {step === 0 && (
              <BasicInfo
                onSelectLocation={onSelectLocation}
                setLoading={setLoading}
                onSubmitFormValue={onSubmitFormValue}
                edit={edit}
                toggle={toggle}
                initialValues={get(formValues, "step1")}
                companies={companies}
                locationId={get(data, "company.location_id")}
              />
            )}

            {step === 1 && (
              <GraphInfo
                entityTree={entityTree}
                onSelectLocation={onSelectLocation}
                setLoading={setLoading}
                goToStep={goToStep}
                localState={graphLocalState}
                setLocalState={setGraphLocalState}
                initialValues={get(formValues, "step2", {})}
                onSubmitFormValue={onSubmitFormValue}
                templateType={get(formValues, "step1.type_id")}
              />
            )}

            {step === 2 && (
              <TemplateMetaValue
                setLoading={setLoading}
                goToStep={goToStep}
                initialValues={get(formValues, "step3")}
                onSubmitFormValue={onSubmitFormValue}
                templateType={get(formValues, "step1.type_id")}
              />
            )}
          </>
        )}
      </Spin>
    </div>
  );
};

export default AddEditTemplate;
